import { useEffect, useState } from "react";
import { useLocation, useSearch } from "wouter";
import { Toast } from "@threadws/jute";

type Notice = { tone: "success" | "danger"; title: string; description?: string };

/** What the Google callback reported, from `?connected=<id>` or `?connectionError=<message>`. */
function readNotice(search: string): Notice | null {
  const params = new URLSearchParams(search);
  const error = params.get("connectionError");
  if (error) return { tone: "danger", title: "Couldn't connect the account", description: error };
  if (params.has("connected")) return { tone: "success", title: "Account connected" };
  return null;
}

/**
 * Shows how connecting an account went, after Google's callback redirects back here. Then
 * removes the query from the URL, so a reload or a shared link doesn't show it again.
 */
export function ConnectionNotice() {
  const search = useSearch();
  const [location, navigate] = useLocation();
  const [notice, setNotice] = useState(() => readNotice(search));

  useEffect(() => {
    if (readNotice(search)) navigate(location, { replace: true });
  }, [search, location, navigate]);

  if (!notice) return null;
  return <Toast tone={notice.tone} title={notice.title} description={notice.description} onClose={() => setNotice(null)} />;
}
